import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';
import { PAYPAL } from '../../../../constants/paymentMethods';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';

import './PaypalStyle.scss';

const Paypal = ({ selectedMethod, handleMethodChange, i18n }) => {
    return (
        <div id="paypal-container" onClick={() => handleMethodChange(PAYPAL)}>
            <div className="paypal-head">
                <div>
                    <input
                        type="radio"
                        id="paypal-bt"
                        name="paypal-bt"
                        value={PAYPAL}
                        checked={selectedMethod === PAYPAL}
                    />

                    <label htmlFor="paypal-bt">{i18n.PAYMENT_CHOICE.PAYPAL}</label>
                </div>
                <div className="paypal-head-text">
                    <p>{convertHtmlToReactDomWithParams(i18n.PAYMENT_CHOICE.PAYPAL_TEXT_1)}</p>
                    <SvgComponent
                        src={`${STATIC_ROOT}/payment/paypal.svg`}
                        width="61"
                        height="15"
                    />
                </div>
            </div>

            {selectedMethod === PAYPAL && (
                <div className="paypal-text">
                    <p>{i18n.PAYMENT_CHOICE.PAYPAL_TEXT_2}</p>
                </div>
            )}
        </div>
    );
};

Paypal.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(Paypal);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/Paypal.js